import { create } from "zustand";

type State = {
  isSubmitting: boolean;
  setIsSubmitting: (isSubmitting: boolean) => void;
};

// Conversion is submitting is extracted to a Zustand store because it needs to be accessed by the tutorial logic
export const useConversionIsSubmitting = create<State>()((set) => ({
  isSubmitting: false,
  setIsSubmitting: (isSubmitting: boolean) => set({ isSubmitting }),
}));
